<template>
  <div class="report--wrap"
       v-if="isDataReady && swasCategory">
    <div class="diagnosis-report">
      <div class="view">
        <report-info :reportType="reportType"
                     :report="report"
                     :shareData="shareData"
                     :scoreData="scoreData"
                     :summaryMap="summaryMap"
                     @onShareClick="onShareClick"
                     @onSaveClick="onSaveClick"
                     @onDocumentViewClick="onDocumentViewClick"
                     @onRemoveClick="onRemoveClick" />
        <div class="detail"
             :style="{ height: `calc(100vh - ${173 + headerHeight}px)` }"
             :class="{ dragging: handleMoving }"
             @mousemove="handleMove"
             @mouseup="handleUp">
          <div class="detail-list"
               :style="{ flexBasis: handlePosition + '%' }">
            <div class="check-list"
                 :class="{ reduce: !showChecklist }">
              <report-check-list :currentCategory="currentCategory"
                                 :isSummary="isSummary"
                                 :summaryMap="summaryMap"
                                 :report="report"
                                 :showChecklist="showChecklist"
                                 @onToggleChecklist="onToggleChecklist"
                                 @onCategoryClick="onCategoryClick"
                                 @onViewTypeChange="onViewTypeChange" />
            </div><div class="report"
                       :class="{ reduce: !showChecklist }">
              <report-summary v-if="isSummary"
                              :report="report"
                              :summaryMap="summaryMap"
                              @onCategoryClick="onCategoryClick" />
              <report-issue-list v-else
                                 :currentCategory="currentCategory"
                                 :categoryResultMap="categoryResultMap"
                                 :nodeDataMap="nodeDataMap"
                                 :issueData="issueData"
                                 :report="report"
                                 :currentIssue="currentIssue"
                                 @onViewTypeChange="onViewTypeChange"
                                 @onIssueClick="onIssueClick" />
            </div>
            <div class="detail-handle"
                 @mousedown="handleDown"></div>
          </div>
          <template v-if="report && report.ReportDatum && report.ReportDatum.deviceType">
            <div v-if="report.ReportDatum.deviceType < 10"
                 :style="{ flexBasis: (100 - handlePosition) + '%' }"
                 class="detail-code">
              <div class="detail-code-wrap">
                <report-capture
                  :issueData="issueData"
                  :report="report"
                  :nodeDataMap="nodeDataMap"
                  :currentIssue="currentIssue"
                  @onImageSizeChanged="onImageSizeChanged" />
                <report-code v-if="!!nodeDataMap"
                  :scrollTop="codeViewScrollTop"
                  :issueData="issueData"
                  :nodeDataMap="nodeDataMap"
                  :currentIssue="currentIssue" />
              </div>
            </div>
            <div v-else
                 :style="{ flexBasis: (100 - handlePosition) + '%' }"
                 class="detail-excel">
              <report-image :issueData="issueData"
                            :scrollTop="codeViewScrollTop"
                            :report="report"
                            :dataMap="nodeDataMap"
                            :currentIssue="currentIssue"
                            :refreshKey="handlePosition" />
            </div>
          </template>
        </div>

        <address :class="{ reduce: !showChecklist }">
          Copyright © {{ (new Date()).getFullYear() }} Seeall. All rights reserved.
          <span class="link">
            <router-link :to="{ name: 'Terms' }">Terms of Service</router-link>
          </span>
                &middot;
                <span class="link">
            <router-link :to="{ name: 'PrivacyEurope' }">Privacy Policy (Europe)</router-link>
            <router-link :to="{ name: 'PrivacyGlobal' }">(Global)</router-link>
          </span>
        </address>
      </div>
    </div>

    <div class="layer-modal"
      v-if="isShowReportSave || isShowReportShare">
      <report-save v-if="isShowReportSave"
                   :report="report"
                   :parentReportData="parentReportData"
                   @onSaveClick="onSaveConfirmClick"
                   @onCancelClick="onSaveCancelClick" />

      <report-share v-if="isShowReportShare"
                    :report="report"
                    :shareData="shareData"
                    @onCancelClick="onShareCancelClick"
                    @onReportShare="onReportShare"
                    @onShareUrlCopy="onShareUrlCopy" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'
import ReportCheckList from './ReportCheckList'
import ReportInfo from './ReportInfo'
import ReportSummary from './ReportSummary'
import ReportIssueList from './ReportIssueList'
import ReportCapture from './ReportCapture'
import ReportImage from './ReportImage'
import ReportCode from './ReportCode'
import ReportSave from './ReportSave'
import ReportShare from './ReportShare'
import NewReportForm from '../NewReportForm'
import tempReportApi from '@/api/temp-report'
import reportDataApi from '@/api/report-data'
import reportApi from '@/api/report'
import modalEvent from '@/lib/modal-event'

export default {
  name: 'Report',
  components: {
    ReportCheckList,
    ReportInfo,
    ReportIssueList,
    ReportSummary,
    ReportImage,
    ReportCapture,
    ReportCode,
    ReportSave,
    ReportShare,
    NewReportForm
  },
  data () {
    return {
      isSummary: true,
      currentCategory: null,
      currentIssue: null,
      codeViewScrollTop: 0,
      codeViewScrollLeft: 0,
      categoryResultMap: {},
      isShowReportSave: false,
      isShowReportShare: false,
      isDataReady: false,
      api: null,
      reportType: null,
      report: {},
      reportId: null,
      issueData: null,
      shareData: null,
      nodeDataMap: null,
      parentReportData: null,
      handleMoving: false,
      handlePosition: 70,
      showChecklist: false
    }
  },
  created () {
    this.initReport()
    if (window.innerWidth >= 1600) {
      this.showChecklist = true
    }
  },
  computed: {
    ...mapState(['headerHeight']),
    ...mapGetters(['swasCategory']),

    scoreData () {
      return this.issueData.scoreData
    },
    summaryMap () {
      const scoreMap = this.issueData.scoreMap
      const summaryMap = {}

      for (const categoryData of Object.values(this.swasCategory)) {
        const categoryId = categoryData.id
        let resultType
        let resultCssClass
        let passCount = 0
        let errorCount = 0
        let criticalPassCount = 0
        let criticalErrorCount = 0
        let criticalPassRule = 0
        let criticalErrorRule = 0

        if (scoreMap[categoryId]) {
          _.each(scoreMap[categoryId], subScore => {
            passCount += subScore.passCount
            errorCount += subScore.errorCount
            criticalPassCount += subScore.criticalPassCount
            criticalErrorCount += subScore.criticalErrorCount
            criticalPassRule += subScore.criticalPassRule
            criticalErrorRule += subScore.criticalErrorRule
          })

          if (errorCount) {
            resultType = 'E'
            resultCssClass = 'error'
          } else if (passCount) {
            resultType = 'None'
            resultCssClass = 'none'
            // resultType = 'P'
            // resultCssClass = 'pass'
          }
        } else {
          resultType = 'None'
          resultCssClass = 'none'
        }

        summaryMap[categoryId] = {
          passCount,
          errorCount,
          criticalPassCount,
          criticalErrorCount,
          criticalPassRule,
          criticalErrorRule,
          resultType,
          resultCssClass
        }
      }

      return summaryMap
    }
  },
  watch: {
    $route (to, from) {
      if (to.name === 'Report' && from.name === 'TempReport') {
        // this.setReportType('saved')
        // this.setReportId(this.$route.params.id)
      } else if (to.params.id !== from.params.id) {
        this.clearReport()
        this.initReport()
        this.onViewTypeChange('summary')
      }
    }
  },
  methods: {
    initReport () {
      this.codeViewScrollTop = 0
      this.codeViewScrollLeft = 0
      this.reportId = Number(this.$route.params.id)

      switch (this.$route.name) {
        case 'TempReport':
          this.reportType = 'temp'
          this.api = tempReportApi
          break
        case 'Report':
          this.reportType = 'saved'
          this.api = reportApi
          break
        default:
          throw new Error(`invalid reportType: ${this.$route.name}`)
      }

      this.api.findById(this.reportId).then(response => {
        this.report = response.data
        this.issueData = this.report.jsonObject
        this.nodeDataMap = this.report.nodeDataObject
        this.isDataReady = true
      }).catch(err => {
        const isHandled = this.handleAjaxError(err)

        if (!isHandled) {
          alert(this.$t('system.wrongApproach'))
          window.location.replace('/')
        }
      })
    },
    onCategoryClick (category) {
      const categoryId = category.id

      if (this.currentCategory && this.currentCategory.id === categoryId) {
        return
      }

      this.onIssueClick(null)

      if (this.issueData.scoreMap[categoryId]) {
        this.api.findCategoryResult(this.reportId, categoryId).then(response => {
          this.categoryResultMap = response.data
          this.currentCategory = category
          this.onViewTypeChange('issue')
        }).catch(this.handleAjaxError)
      } else {
        this.categoryResultMap = {}
        this.currentCategory = category
        this.onViewTypeChange('issue')
      }
    },
    onViewTypeChange (value) {
      this.isSummary = value === 'summary'
      this.onIssueClick(null)

      if (this.isSummary) {
        this.currentCategory = null
      }
    },
    onIssueClick (issueData) {
      if (issueData) {
        this.currentIssue = _.cloneDeep(issueData)
      } else {
        this.currentIssue = null
      }

      if (this.currentIssue) {
        const el = document.getElementById(`code-id-${this.currentIssue.id}`)

        if (el) {
          this.codeViewScrollTop = el.offsetTop - 5
        }
      }
    },
    onShareClick () {
      this.isShowReportShare = true
      // const id = this.reportId
    },
    onShareCancelClick () {
      this.isShowReportShare = false
    },
    onReportShare (shareData) {
      this.shareData = shareData
    },
    onSaveClick () {
      const reportData = { ...this.report.ReportDatum }
      if (reportData.deviceType !== 1 && reportData.deviceType < 10) {
        reportData.deviceType = 1
      }
      reportDataApi.findByOptions(reportData).then(response => {
        this.parentReportData = response.data
        this.isShowReportSave = true
      }).catch(this.handleAjaxError)
    },
    onSaveConfirmClick (reportData) {
      this.isShowReportSave = false
      modalEvent.openDialog({
        message: 'diagnostics.reportSavedMessage',
        ok: 'common.yes',
        cancel: 'common.no'
      }).then(result => {
        if (result) {
          this.$router.replace({ name: 'Main' })
        } else {
          this.$router.replace({ name: 'Report', params: { id: reportData.id } })
          this.initReport()
        }
      })
    },
    onSaveCancelClick () {
      this.isShowReportSave = false
    },
    onRemoveClick () {
      const reportId = this.report.mainReport || this.report.id
      modalEvent.openDialog({
        message: 'report.deletePageMessage',
        ok: 'common.delete',
        cancel: 'common.cancel'
      }).then(result => {
        if (result) {
          return reportApi.remove(reportId)
        }
        throw this.getHandledError()
      }).then(response => {
        modalEvent.openToast('common.deleted').then(() => {
          this.$router.replace({ name: 'Main' })
        })
      }).catch(this.handleAjaxError)
    },
    onShareUrlCopy () {
      modalEvent.openToast('shareReport.copied').then(() => {
        this.onShareCancelClick()
      })
    },
    onImageSizeChanged () {
      this.onIssueClick(null)
    },
    clearReport () {
      this.isDataReady = false
    },
    onDocumentViewClick () {
      const url = location.href.replace(/\/report\//i, '/report/view/')
      window.open(url)
    },
    handleDown () {
      this.handleMoving = true
    },
    handleMove (event) {
      if (this.handleMoving) {
        this.handlePosition = Math.min(Math.max(((event.clientX - 10) / (window.innerWidth - 20)) * 100, 10), 90)
      }
    },
    handleUp () {
      this.handleMoving = false
    },
    onToggleChecklist () {
      this.showChecklist = !this.showChecklist
    }
  },
  destroyed () {
    this.clearReport()
  }
}
</script>

<style lang="scss" scoped>
.diagnosis-report {
  .view {
    margin: 0 10px;

    address {
      padding: 0 0 10px 250px;
      height: 20px;
      font-size: 12px;
      font-style: normal;
      text-align: left;
      color: #767676;
      line-height: 1.7;
      transition: padding-left 0.3s ease;

      &.reduce {
        padding-left: 70px;
      }

      .link {
        margin: 0 5px;
      }
    }

    .detail {
      display: flex;
      flex-wrap:nowrap;
      height: calc(100vh - 200px);

      &.dragging * {
        user-select: none;
      }

      .detail-list {
        flex-basis: 70%;
        flex-grow: 1;
        margin: 10px;
        position: relative;
        transition: flex-basis 0.2s ease;

        .check-list {
          display: inline-block;
          height: 100%;
          width: 210px;
          margin-right: 20px;
          vertical-align: top;
          position: relative;
          transition: width 0.3s ease,
                      height 0.2s ease;

          &.reduce {
            width: 33px;
            height: 33px;
          }
        }

        .report {
          display: inline-block;
          height: 100%;
          width: calc(100% - 230px);
          vertical-align: top;
          transition: width 0.3s ease;

          &.reduce {
            width: calc(100% - 53px);
          }
        }

        .detail-handle {
          position: absolute;
          top: 50%;
          right: -18.5px;
          transform: translateY(-50%);
          width: 14px;
          height: 94px;
          background: url('../../../assets/asset-handle.svg') no-repeat;
          cursor: ew-resize;
        }
      }

      .detail-code,
      .detail-excel {
        flex-basis: 30%;
        flex-grow: 1;
        overflow: hidden;
        margin: 10px;
        transition: flex-basis 0.2s ease;
      }

      .detail-code {
        border-radius: 10px;
        box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);

        .detail-code-wrap {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
      }
    }
  }
}

.toast-wide { min-width: 350px; }
</style>



// WEBPACK FOOTER //
// src/components/valid-member/report/index.vue